export default __webpack_public_path__ + "ab4e7d75dd5fab35acf90eaadb651d67.png";